module.exports = __webpack_public_path__ + "static/usopen-04-b5a79d7b268e40967208786db067a631.jpg";